import { IGetOrderDetailsResponse } from '../../types/api/response/logisticsorderdetailsresponse';
import axiosClient from '../axiosClient';
import { LogisticsOrderDetailsEndpoint } from '../endpoints/logisticsOrderDetails';

export const LogisticsOrderDetailsService = {
  async getOrderDetails(orderNumber: string): Promise<IGetOrderDetailsResponse> {
    const res = await axiosClient.get<IGetOrderDetailsResponse>(
      `${LogisticsOrderDetailsEndpoint.RETRIEVE_ORDER_DETAILS}/${orderNumber}`,
    );
    console.log(res.data);
    return res.data;
  },
};
